// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"84abf938","522":"4c765b5c","905":"d92f2c1e"}[chunkId] + ".chunk.js";
};